import React, { useState, useEffect, createContext, useContext } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AppAuthContext = createContext(null);

export const useAppAuth = () => {
  const context = useContext(AppAuthContext);
  if (!context) {
    throw new Error('useAppAuth must be used within AppAuthProvider');
  }
  return context;
};

export const AppAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedToken = localStorage.getItem('app_token');
    const savedUser = localStorage.getItem('app_user');
    if (savedToken && savedUser) {
      setToken(savedToken);
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = async (cnpj, cpf, email, senha) => {
    try {
      const response = await fetch(`${API_URL}/api/app/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          cnpj: cnpj.replace(/\D/g, ''),
          cpf: cpf.replace(/\D/g, ''),
          email: email.trim().toLowerCase(),
          senha
        })
      });

      const data = await response.json();

      if (response.ok) {
        setToken(data.access_token);
        setUser(data.user);
        localStorage.setItem('app_token', data.access_token);
        localStorage.setItem('app_user', JSON.stringify(data.user));
        return { success: true };
      }

      return { success: false, error: data.detail || 'Erro ao fazer login' };
    } catch (error) {
      return { success: false, error: 'Erro de conexão' };
    }
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('app_token');
    localStorage.removeItem('app_user');
  };

  const authHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };

  return (
    <AppAuthContext.Provider value={{ user, token, loading, login, logout, authHeaders, isAuthenticated: !!token }}>
      {children}
    </AppAuthContext.Provider>
  );
};

export default AppAuthProvider;
